/**
 * @module CommonComponents
 */

import { Paper, Typography } from '@mui/material'
import { BarChart } from '@mui/x-charts/BarChart'

/**
 * Componente reutilizable de gráfico de barras basado en MUI X Charts
 * @param {CustomBarChartProps} props
 */
const CustomBarChart = ({
  title,
  labels = [],
  series = [],
  height = 300,
  xAxisLabel,
  yAxisLabel,
  borderRadius = 8,
  sx = {},
}) => {
  return (
    <Paper sx={{ p: 3, ...sx }}>
      {title && (
        <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
          {title}
        </Typography>
      )}
      <BarChart
        xAxis={[{ scaleType: 'band', data: labels, label: xAxisLabel }]}
        yAxis={[{ label: yAxisLabel }]}
        series={series}
        height={height}
        borderRadius={borderRadius}
      />
    </Paper>
  )
}

export default CustomBarChart

/**
 * @typedef CustomBarChartSeries
 * @prop {Array<number>} data - Valores de la serie
 * @prop {string} label - Nombre de la serie (aparece en leyenda)
 * @prop {string} [color] - Color de las barras
 */

/**
 * @typedef CustomBarChartProps
 * @prop {string} [title] - Título del gráfico
 * @prop {Array<string>} labels - Etiquetas del eje X
 * @prop {Array<CustomBarChartSeries>} series - Series de datos
 * @prop {number} [height=300] - Altura del gráfico en píxeles
 * @prop {string} [xAxisLabel] - Etiqueta del eje X
 * @prop {string} [yAxisLabel] - Etiqueta del eje Y
 * @prop {number} [borderRadius=8] - Radio de borde de las barras
 * @prop {import('@mui/system').SxProps} [sx] - Estilos adicionales del contenedor
 */
